import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import I18nWrapper from './i18n-wrapper';

function Loading(props: { message: string; sizeRelativeTo?: string }) {
  return (
    <Container>
      <Row
        className={`d-flex align-items-center ${
          !props.sizeRelativeTo ? 'vh-100' : props.sizeRelativeTo
        }`}
      >
        <Col className="text-center">
          <FontAwesomeIcon
            aria-label="Home"
            icon={faCircleNotch}
            size="2x"
            spin={true}
          />
          <p>
            <I18nWrapper translateKey={props.message} />
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default Loading;
